<h2 mat-dialog-title class="sd-title">
  <mat-icon>draw</mat-icon>
  {{ title }}
  <span class="sd-orderid">N° {{ data.orderId }}{{ data.customerLabel ? ' — ' + data.customerLabel : '' }}</span>
</h2>

<mat-dialog-content class="sd-content">
  <!-- Le PDF du serveur, pas l'aperçu HTML : le client signe ce qu'il lit, pagination et pied de page compris. -->
  <section class="sd-preview">
    @if (loading) {
      <div class="sd-preview-state"><mat-spinner diameter="28"></mat-spinner><span>Préparation du {{ docLabel }}…</span></div>
    } @else if (loadError) {
      <div class="sd-preview-state error"><mat-icon>error_outline</mat-icon><span>{{ loadError }}</span></div>
    } @else {
      <iframe class="sd-frame" [src]="docUrl" [title]="title"></iframe>
    }
  </section>

  <section class="sd-signature">
    <div class="sd-signature-head">
      <div class="sd-signature-label">Signature du client (acceptation du {{ docLabel }})</div>
      <button type="button" class="custom-filled-button neutral sd-clear" aria-label="Effacer la signature" (click)="clearSignature()">
        <mat-icon>clear</mat-icon>
        Effacer
      </button>
    </div>
    <!-- Même pad que le BL et le relevé d'heures. La remarque est ouverte parce que le cadre
         d'acceptation du devis et du bon de commande sait l'imprimer. -->
    <app-signature-pad class="sd-signature-canvas"
      noteLabel="Remarque du client (facultative — imprimée sur le document signé)"
      notePlaceholder="Réserve, précision, délai souhaité…"></app-signature-pad>
    @if (!signatureValid()) {
      <div class="sd-signature-hint">Faites signer le client pour enregistrer le {{ docLabel }}.</div>
    }
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="sd-actions">
  <button type="button" class="custom-filled-button error" aria-label="Annuler" [disabled]="posting" (click)="onCancel()">
    <mat-icon>close</mat-icon>
    Annuler
  </button>
  <button type="button" class="custom-filled-button success" [attr.aria-label]="'Enregistrer le ' + docLabel + ' signé'" [disabled]="posting || !signatureValid()" (click)="onSign()">
    <mat-icon>done</mat-icon>
    Enregistrer le {{ docLabel }} signé
  </button>
</mat-dialog-actions>
